// import { extendWidth } from "../LoadExam/Utils";
import { extendWidth } from "../LoadExam/Utils";
import { inputResult } from "../Submit/SaveAnswer";


export function transformLaToResult(input:JQuery, results:inputResult, points:number, possible:number){
    
    const labels = input.find(".label-item");

    // Loop through fields
    labels.each((ind, obj) => {
        // Disable Field
        const input = $(obj).find("input");
        input.prop('readonly', true);

        input.attr('value', results.answer[ind].answer);
        
        // Now displayResult
        if (results.answer[ind].right){
            input.addClass("is-valid");
        } else {
            input.addClass("is-invalid")
            input.attr('title', 'Richtige Antwort: ' + results.correct[ind]);
        }

        // Extend Width
        extendWidth(input) // did not work properly -> because bound by label width


    })


}